
import Header from '../../components/feature/Header';
import HeroSection from '../../components/feature/HeroSection';
import FeaturedProject from '../../components/feature/FeaturedProject';
import LuxuryCollection from '../../components/feature/LuxuryCollection';
import PinnacleProject from '../../components/feature/PinnacleProject';
import HomeIntro from '../../components/feature/HomeIntro';
import HomeTextBlocks from '../../components/feature/HomeTextBlocks';
import HomeAwardsGallery from '../../components/feature/HomeAwardsGallery';
import ContactSection from '../../components/feature/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      {/* WHY-style intro below hero */}
      <HomeIntro />
      <FeaturedProject />
      <LuxuryCollection />
      {/* Two text blocks below Branded Luxury Collection */}
      <HomeTextBlocks />
      <PinnacleProject />
      {/* Convert awards to gallery slider */}
      <HomeAwardsGallery />
      <ContactSection page="home" showFloatingIcons={true} />
    </div>
  );
}
